<template>
  <v-dialog
    ref="dialog"
    v-model="dialogOpened"
    max-width="450"
    scrollable
    persistent
    no-click-animation
    :retain-focus="false"
  >
    <v-card>
      <v-card-title class="headline">
        <template v-if="useMobileSafari">
          <div class="text-center text-sm-left">
            <v-icon color="warning" class="mb-1 mb-sm-0">fas fa-exclamation-triangle</v-icon>
            <br class="d-sm-none">
            Browser unterstützt nicht alle Funktionen
          </div>
        </template>
        <template v-else>
          <v-icon color="warning">fas fa-exclamation-triangle</v-icon>
          Browser veraltet
        </template>
      </v-card-title>

      <v-card-text>
        <template v-if="useMobileSafari">
          Wechsle zu Safari für das beste Nutzererlebnis auf iOS.
        </template>
        <template v-else>
          Du verwendest einen veralteten Browser.<br>
          Aktualisiere deinen Browser auf die neueste Version für das beste Nutzererlebnis.
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn depressed outlined color="warning" @click="hide">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Dialog from './Dialog';
  import {serviceWorkerSupported} from '../../assets/js/utils';


  export default {
    name: 'LegacyWarning',

    extends: Dialog,

    computed: {
      browser() {
        const peerSelf = this.$store.getters['share/getPeerSelf'];
        if (peerSelf?.name) {
          return {
            name: peerSelf?.name.browser,
            os: peerSelf?.name.os
          };
        }
        return {};
      },

      useMobileSafari() {
        const {name, os} = this.browser;
        return os === 'iOS' && name !== 'Mobile Safari';
      }
    },

    mounted() {
      const legacyWarningAccepted = sessionStorage.getItem('legacy_warning_accepted');
      if (!serviceWorkerSupported && !legacyWarningAccepted) {
        this.show();
      }
    },

    methods: {
      hide() {
        if (this.dialogOpened) {
          sessionStorage.setItem('legacy_warning_accepted', true);
          Dialog.methods.hide.call(this);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .headline {
    line-height: 1.4;
    margin: 0.15em 0; // Add margin cause of smaller line-height.
  }

  .v-dialog > .v-card {
    border: 1px solid $warning-light;
    border-radius: 4px !important;
  }
</style>
